import { FETCH_GUIDES, SET_ACTIVE_GUIDE } from './constants'

export const setActiveGuide = activeGuide => ({
  type: SET_ACTIVE_GUIDE,
  activeGuide
})

export const fetchGuides = {
  request: currentPhoneId => ({
    type: FETCH_GUIDES['REQUEST'],
    currentPhoneId
  }),
  success: (guides, currentPhoneId) => ({
    type: FETCH_GUIDES['SUCCESS'],
    guides,
    currentPhoneId
  })
}



// WEBPACK FOOTER //
// ./src/containers/Guides/actions.js